import { render, staticRenderFns } from "./FrsModuleRoot.vue?vue&type=template&id=7e864fa8&scoped=true&lang=html&"
import script from "./FrsModuleRoot.vue?vue&type=script&lang=js&"
export * from "./FrsModuleRoot.vue?vue&type=script&lang=js&"
import style0 from "./FrsModuleRoot.vue?vue&type=style&index=0&id=7e864fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e864fa8",
  null
  
)

export default component.exports